/* global wpApiSettings */

import { createAsyncThunk } from '@reduxjs/toolkit';
import { wpBase, realtyBase } from '../api/base';
import axios from 'axios';

////////////////WP REST API////////////////

// FETCH HOUSE
const fetchWpHouse = createAsyncThunk(
  'house/fetch',
  async ({ pageKeyWp, category }) => {
    const response = await wpBase.get(
      `/wp-json/wp/v2/hp_listing?hp_listing_category=${category}&page=${pageKeyWp}&per_page=100`
    );
    return response;
  }
);

// FETCH HOUSE DETALS
const fetchWpHouseDetails = createAsyncThunk(
  'houseDetails/fetch',
  async (carId) => {
    const response = await wpBase.get(`/wp-json/wp/v2/hp_listing/${carId}`);
    return response;
  }
);

// FETCH VENDORS
const fetchWpVendors = createAsyncThunk('vendors/fetch', async (vendorId) => {
  const response = await wpBase.get(`/wp-json/wp/v2/hp_vendor/${vendorId}`);
  return response;
});

////////////////THIRD PARTY API////////////////

// FETCH HOUSE
const fetchNotionHouse = createAsyncThunk(
  'houseNotion/fetch',
  async (params) => {
    const {
      lat = '',
      lng = '',
      radius = '',
      priceVal = [],
      bedsVal = [],
      bathsVal = [],
      sizeSqFtVal = [],
      homeType = [],
      unitType = '',
      propertyFeatures = [],
      rentalPropertyFeatures = [],
      otherApiCategory = '',
    } = params;

    /////////// OLD API /////////////

    // PRICE
    const priceMin = priceVal[0];
    const priceMax = priceVal[1];
    const showPrice =
      priceVal.length > 0
        ? `&mls_listing_price_min=${priceMin}&mls_listing_price_max=${priceMax}`
        : '';

    // BEDS
    const bedsMin = bedsVal[0];
    const bedsMax = bedsVal[1];
    const showBeds =
      bedsVal.length > 0 ? `&bedsMin=${bedsMin}&bedsMax=${bedsMax}` : '';

    // BATHS
    const bathsMin = bathsVal[0];
    const bathsMax = bathsVal[1];
    const showBaths =
      bathsVal.length > 0 ? `&bathsMin=${bathsMin}&bathsMax=${bathsMax}` : '';

    // SIZE SQFT
    const sizeSqFtMin = sizeSqFtVal[0];
    const sizeSqFtMax = sizeSqFtVal[1];
    const showSizeSqFt =
      sizeSqFtVal.length > 0
        ? `&sizeSqFtMin=${sizeSqFtMin}&sizeSqFtMax=${sizeSqFtMax}`
        : '';

    // HOME TYPE
    let propertyType = '';
    let story = [];
    let showHomeType = '';

    if (homeType.length > 0) {
      const type = homeType[0]; // Store the first value in a variable

      if (type.includes('1-Story Home')) {
        propertyType = 'SFR';
        story = [1, 1];
      } else if (type.includes('2-Story Home')) {
        propertyType = 'SFR';
        story = [2, 2];
      } else if (type.includes('3+ Story Home')) {
        propertyType = 'SFR';
        story = [3, 10];
      } else if (type.includes('Apartment')) {
        propertyType = 'MFR';
        story = [0, 200];
      } else if (type.includes('Condominium')) {
        propertyType = 'CONDO';
        story = [0, 200];
      }

      showHomeType = `&propertyType=${propertyType}&storiesMin=${story[0]}&storiesMax=${story[1]}`;
    }

    // UNIT TYPE
    let unitPropertyType = '';
    let unitStory = [];
    let showUnitType = '';

    if (unitType && unitType.length > 0) {
      const type = unitType[0];

      if (type.includes('1-Story Home')) {
        unitPropertyType = 'SFR';
        unitStory = [1, 1];
        showUnitType = `&propertyType=${unitPropertyType}&storiesMin=${unitStory[0]}&storiesMax=${unitStory[1]}`;
      } else if (type.includes('2-Story Home')) {
        unitPropertyType = 'SFR';
        unitStory = [2, 2];
        showUnitType = `&propertyType=${unitPropertyType}&storiesMin=${unitStory[0]}&storiesMax=${unitStory[1]}`;
      } else if (type.includes('3+ Story Home')) {
        unitPropertyType = 'SFR';
        unitStory = [3, 10];
        showUnitType = `&propertyType=${unitPropertyType}&storiesMin=${unitStory[0]}&storiesMax=${unitStory[1]}`;
      } else if (type.includes('Apartment')) {
        unitPropertyType = 'MFR';
        unitStory = [0, 200];
        showUnitType = `&propertyType=${unitPropertyType}&storiesMin=${unitStory[0]}&storiesMax=${unitStory[1]}`;
      } else if (type.includes('Studio/Efficiency')) {
        unitPropertyType = 'CONDO';
        unitStory = [0, 200];
        showUnitType = `&propertyType=${unitPropertyType}&storiesMin=${unitStory[0]}&storiesMax=${unitStory[1]}&beds_min=0&beds_max=0`;
      }
    }

    // PROPERTY FEATURES
    let showPropFeatures = '';
    let attic = false;
    let basement = false;
    let garage = false;
    let carport = false;
    let deck = false;
    let fireSprinklers = false;
    let pool = false;

    if (propertyFeatures.length > 0) {
      if (propertyFeatures.includes('Attic')) {
        attic = true;
      }
      if (propertyFeatures.includes('Basement')) {
        basement = true;
      }
      if (propertyFeatures.includes('Garage')) {
        garage = true;
      }
      if (propertyFeatures.includes('Off-Street Parking')) {
        carport = true;
      }
      if (propertyFeatures.includes('Outdoor Deck/Patio')) {
        deck = true;
      }
      if (propertyFeatures.includes('Sprinkler System')) {
        fireSprinklers = true;
      }
      if (propertyFeatures.includes('Pool')) {
        pool = true;
      }

      // Build the showPropFeatures string
      const features = [];
      if (attic) features.push('attic=true');
      if (basement) features.push('basement=true');
      if (garage) features.push('garage=true');
      if (carport) features.push('carport=true');
      if (deck) features.push('deck=true');
      if (fireSprinklers) features.push('fireSprinklers=true');
      if (pool) features.push('pool=true');

      // Join the features with '&' for a query string format
      showPropFeatures = '&' + features.join('&');
    }

    // RENTAL PROPERTY FEATURES
    let showRentalPropFeatures = '';
    let atticRental = false;
    let basementRental = false;
    let garageRental = false;
    let carportRental = false;
    let deckRental = false;
    let fireSprinklersRental = false;
    let poolRental = false;

    if (rentalPropertyFeatures.length > 0) {
      if (rentalPropertyFeatures.includes('Attic')) {
        atticRental = true;
      }
      if (rentalPropertyFeatures.includes('Basement')) {
        basementRental = true;
      }
      if (rentalPropertyFeatures.includes('Garage')) {
        garageRental = true;
      }
      if (rentalPropertyFeatures.includes('Off-Street Parking')) {
        carportRental = true;
      }
      if (rentalPropertyFeatures.includes('Outdoor Deck/Patio')) {
        deckRental = true;
      }
      if (rentalPropertyFeatures.includes('Sprinkler System')) {
        fireSprinklersRental = true;
      }
      if (rentalPropertyFeatures.includes('Pool')) {
        poolRental = true;
      }

      // Build the showRentalPropFeatures string
      const features = [];
      if (atticRental) features.push('attic=true');
      if (basementRental) features.push('basement=true');
      if (garageRental) features.push('garage=true');
      if (carportRental) features.push('carport=true');
      if (deckRental) features.push('deck=true');
      if (fireSprinklersRental) features.push('fireSprinklers=true');
      if (poolRental) features.push('pool=true');

      // Join the features with '&' for a query string format
      showRentalPropFeatures = '&' + features.join('&');
    }

    // Property Types
    const propertyUseCodes = [
      // SFR codes
      376, 380, 382, 383, 385, 386,
      // MFR codes
      357, 358, 359, 360, 361, 369, 372, 378, 381, 388,
      // CONDO codes
      201, 364, 366,
    ];

    const propertyUseQuery = propertyUseCodes
      .map((code) => `&property_use_code=${code}`)
      .join('');

    // const url =
    //   `${wpApiSettings.root}fz-housing-long-api/v1/data?lat=${lat}&lng=${lng}&radius=${radius}` +
    //   propertyUseQuery +
    //   `${showBeds}${showBaths}${showPrice}${showSizeSqFt}${showHomeType}` +
    //   `${showUnitType}${showPropFeatures}${showRentalPropFeatures}`;

    // try {
    //   // Fetch data from the custom WordPress API endpoint
    //   const response = await axios.get(url, {
    //     headers: {
    //       'X-WP-Nonce': wpApiSettings.nonce, // Include nonce for security
    //     },
    //   });
    //   // Return the response data
    //   console.log(response.data);
    //   return response;
    // } catch (error) {
    //   // Handle any errors during the request
    //   console.error('Error fetching data from API:', error);
    //   throw error;
    // }

    /////////// OLD API ENDS /////////////

    try {
      const url = new URL(
        'https://api.rentcast.io/v1/listings/rental/long-term'
      );

      // Required parameters
      url.searchParams.set('latitude', lat);
      url.searchParams.set('longitude', lng);
      url.searchParams.set('radius', radius);
      url.searchParams.set('bedrooms', bedsMin);
      url.searchParams.set('bathrooms', bathsMin);
      url.searchParams.set('propertyType', unitType);

      // Keep other filters like status and limit:
      url.searchParams.set('status', 'Active');
      url.searchParams.set('limit', '112');

      // Fetch data from RentCast API with nonce + API key
      const response = await axios.get(url.toString(), {
        headers: {
          Accept: 'application/json',
          'X-Api-Key': process.env.REACT_APP_REALTY_API_KEY,
          'X-WP-Nonce': wpApiSettings.nonce,
        },
      });
      console.log('PREFLIGHT');
      console.log(response);
      console.log('PREFLIGHT');
      return response;
    } catch (error) {
      console.error('Error fetching data from RentCast API:', error);
      throw error;
    }
  }
);

// FETCH HOUSE DETALS & VENDORS
const fetchNotionHouseDetails = createAsyncThunk(
  'realtyHouseDetails/fetch',
  async (carId) => {
    const response = await realtyBase.get(
      `/v2/listing/car/${carId}?api_key=${process.env.REACT_APP_REALTY_API_KEY}`
    );
    return response;
  }
);

export {
  fetchWpHouse,
  fetchWpHouseDetails,
  fetchNotionHouse,
  fetchNotionHouseDetails,
  fetchWpVendors,
};
